var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBak(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_bak") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.414,2H5V30H27V8.586ZM7,28V4H19v6h6V28Z",
    fill: "#c5c5c5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.856,9.659a10.743,10.743,0,0,1,7.893,3.249A10.739,10.739,0,0,1,32,20.8a10.739,10.739,0,0,1-3.25,7.891,10.743,10.743,0,0,1-7.893,3.249,10.7,10.7,0,0,1-6.789-2.321l1.74-1.74a8.835,8.835,0,0,0,5.049,1.568A8.624,8.624,0,0,0,29.505,20.8a8.624,8.624,0,0,0-8.649-8.647A8.624,8.624,0,0,0,12.207,20.8h3.714l-4.99,4.934L6,20.8H9.713a10.739,10.739,0,0,1,3.25-7.891A10.758,10.758,0,0,1,20.856,9.659Z",
    fill: "#99b8c4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBak);
export default __webpack_public_path__ + "static/media/bak.e6ccd7c7f5985b37c0e0cf86a1b8ecbe.svg";
export { ForwardRef as ReactComponent };